import { gql } from '@apollo/client';

export interface ReviewsAggregate {
  strapi_reviews_aggregate: {
    aggregate: {
      count: number;
      avg: {
        rating: number;
      };
    };
  };
}

export const REVIEWS_AGGREGATE_QUERY = gql`
  query ReviewsAggregate {
    strapi_reviews_aggregate {
      aggregate {
        count
        avg {
          rating
        }
      }
    }
  }
`;
